import { denormalize } from 'normalizr';
import { path, uniqBy } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';
import { getOpDefsByIds } from 'modules/opDefs/data/reducer';

import { types } from './actions';
import * as entities from './entities';

const initialState = {
  entities: {},
  processIds: [],
  processClassIds: [],
};

const entitiesReducer = createEntitiesReducer(
  [
    'processes',
    'processFinishes',
    'finishes',
    'processMaterials',
    'materials',
    'opDefs',
    'manufacturers',
    'machines',
    'variables',
  ],
  [types.FETCH_PROCESSES],
);

const reducer = (state, action) => {
  switch (action.type) {
    case types.FETCH_PROCESSES:
      return {
        ...state,
        processIds: action.payload.result,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

export const getScope = (state) => state.modules.processes.data;

export const getProcesses = (state) =>
  denormalize(
    getScope(state).processIds,
    [entities.processSchema],
    getScope(state).entities,
  );

export const getProcessById = (state, processId) =>
  denormalize(processId, entities.processSchema, getScope(state).entities);

export const getAvailableFinishOpDefs = (state, processId) => {
  if (!processId) return [];
  const process = denormalize(
    processId,
    entities.processSchema,
    getScope(state).entities,
  );
  if (!process) return [];
  const { finishOpDefIds } = process;
  const opDefs = getOpDefsByIds(state, finishOpDefIds);

  return uniqBy(path(['id']), opDefs);
};
